module.exports = __webpack_public_path__ + "img/branches.eee5aa7a.svg";